<div class="tax-cuts-container animate-card">
    <div class="card-header">
      <h2>Meter Tax Cut Eligibility</h2>
    </div>
    
    <div class="card-body">
      <!-- Search or filter section -->
      <!-- <div class="search-section animate-field" style="--index: 0">
        <div class="search-container">
          <input type="text" class="search-input" placeholder="Search meter ID..." [(ngModel)]="searchTerm" (input)="filterMeters()">
          <button class="search-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>
      </div> -->
      
      <!-- Summary section -->
    <div class="summary-section animate-field" style="--index: 1">
      <div class="summary-card">
        <div class="summary-title">Total Eligible Meters</div>
        <div class="summary-value">{{ getEligibleCount() }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-title">Total Tax Cuts</div>
        <div class="summary-value highlight">€{{ getTotalTaxCuts().toFixed(2) }}</div>
      </div>
    </div>
      
      <!-- Meters list -->
      <div class="meters-list animate-field" style="--index: 2">
        <div class="list-header">
          <div class="meter-id">Meter ID</div>
          <div class="tax-cut">Tax Cut</div>
          <div class="consumption">Consumption (kWh)</div>
          <div class="status">Status</div>
        </div>
        
        <div class="meter-item" *ngFor="let meter of filteredMeters; let i = index" 
             [ngClass]="{'animate-field': true, 'eligible': meter.isEligible}" 
             [style.--index]="i + 3">
          
          <div class="meter-id">{{ meter.id }}</div>
          
          <div class="tax-cut" data-label="Tax Cut:">
            <div class="data-box">
              {{ meter.taxCut ? '€' + meter.taxCut.toFixed(2) : '-' }}
            </div>
          </div>
          
          <div class="consumption" data-label="Consumption:">
            <div class="data-box">
              {{ meter.consumption | number:'1.0-2' }}
            </div>
          </div>
          
          <div class="status">
            <div class="status-icon" [ngClass]="{'eligible': meter.isEligible, 'not-eligible': !meter.isEligible}">
              <svg *ngIf="meter.isEligible" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <svg *ngIf="!meter.isEligible" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
          </div>
        </div>
        
        <!-- Empty state -->
        <div class="empty-state" *ngIf="filteredMeters.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
          <p>No meters found matching your search</p>
        </div>
      </div>
    
<!-- Actions section -->
<div class="actions-section animate-field" style="--index: 20">
  <!-- Start Again button -->
  <button class="refresh-button" (click)="goToHome()">
    <div class="icon-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
    </div>
    Start Again
  </button>
  
  <!-- Export PDF button -->
  <button class="export-button" (click)="exportPDF()">
    <div class="icon-container">
      <img src="assets/pdf.png" alt="PDF" width="20" height="20">
    </div>
    Export PDF
  </button>

  <button class="export-button" (click)="exportCSV()">
    <div class="icon-container">
      <img src="assets/xls.png" alt="Excel" width="20" height="20">
    </div>
    Export CSV
  </button>
</div>

    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner"></div>
      </div>
    </div>
  </div>